<template>
  <div class="">
    <div v-if="!isHorizontal">{{ field.name }}</div>
    <v-select
      v-model="select"
      :options="selectOptions"
      :clearable="false"
      @input="onChange"
      :disabled="isFieldDisabled"
      class="white-bg"
      append-to-body
    />
    <div class="d-flex flex-column">
      <span class="textHint" v-if="hint">{{ hint }}</span>
      <span class="text-error" v-if="error">{{ error }}</span>
    </div>
  </div>
</template>
<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";
import vSelect from "vue-select";

export default {
  components: {
    vSelect
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
    const isFieldDisabled = ref(false);
    const select = ref("");
    const hint = ref("");
    const maxLength = ref(4000);
    const error = ref(null);
    const selectOptions = ref([]);

    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.name] || null;
      },
      { immediate: true }
    );

    watch(
      () => props?.field?.options?.fieldTypeCfg?.data,
      (newValue, oldValue) => {
        selectOptions.value = setSelectOptions(props?.field?.options?.fieldTypeCfg?.data)
        select.value = null
        onChange()
      },
      { immediate: true }
    );

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isFieldDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    onMounted(async () => {
      selectOptions.value = setSelectOptions(props?.field?.options?.fieldTypeCfg?.data, true)
      hint.value = props?.field?.options?.fieldTypeCfg?.data[0]?.hint;
      isFieldDisabled.value = props.isFormDisabled
    });

    function onChange() {
      emit("updateData", props.field, select.value?.value);
    }

    function setSelectOptions(options, isFirstLoading) {
      const isClassification = isFirstLoading && props?.field?.name === "Clasificación"
      const isCategory = isFirstLoading && props?.field?.name === "Categoría"
      const isSubCategory = isFirstLoading && props?.field?.name === "Subcategoría"
      const isTipeEvent = isFirstLoading && props?.field?.name === "Tipo de evento."
      if(!options || isClassification || isCategory || isSubCategory || isTipeEvent) return [];
      return options.map(item => ({
        label: item.name,
        value: item.name
      }))
    }

    return {
      uniqueId,
      isFieldDisabled,
      selectOptions,
      select,
      hint,
      maxLength,
      error,
      onChange,
    }
  }
}
</script>
<style scoped lang="scss">
.text-error {
  color: #ec0303;
}
.white-bg {
  background-color: #fff;
}
</style>